import React, { createContext, useReducer, useContext,useState } from "react";
import { LiferayService } from "../../../common/services/liferay/index";
import { ApplicationPropertiesContext } from "../../../common/context/ApplicationPropertiesProvider";
import { getCurrentTime } from "../../../common/utils/utilsFunc";

export const ResponseLetterContext = createContext();
export const ACTIONS = {
    SET_NUM_ID: "SET_NUM_ID",
    SET_RESPONSE_LETTER: "SET_RESPONSE_LETTER",
    SET_ERROR:"SET_ERROR"

};
const initialState = {
    numId: null,
    responseLetter: null,
    errorFetch: null

};
const ResponseLetterReducer = (state = initialState, action) => {
  switch (action.type) {
    case ACTIONS.SET_NUM_ID: {
      return {
        ...state,
        numId: action.payload,
      };
    }
    case ACTIONS.SET_RESPONSE_LETTER: {
        return {
          ...state,
          responseLetter: action.payload,
        };
    }
    case ACTIONS.SET_ERROR: {
        return {
          ...state,
          errorFetch: action.payload,
        };
    }
    default: {
      return state;
    }
  }
};
const ResponseLetterContextProvider = ({ children }) => {
  const properties = useContext(ApplicationPropertiesContext);

  const [state, dispatch] = useReducer(ResponseLetterReducer, initialState);

  React.useEffect(() => {
    if (state.numId) {
      LiferayService.getCard(properties.base_url_api, state.numId, properties.url_ws_empresa, properties.codigo_empresa,true)
        .then((response) => {
            dispatch({
                payload: response,
                type: ACTIONS.SET_RESPONSE_LETTER,
            })
            dispatch({
                payload: null,
                type: ACTIONS.SET_ERROR,
            });
            
            const blob = new Blob([response.buffer], { type: 'application/pdf' });
            const fileURL = URL.createObjectURL(blob);
            
            if(!response.status) {
              let link = document.createElement('a');
              link.download = response.filename;
              link.href = fileURL
              link.click()
            }
          })
          .catch((error) => {
            console.error(error);
            dispatch({
              payload: error.message,
              type: ACTIONS.SET_ERROR,
            });
          })
    }
  }, [state.numId]);

  return (
    <ResponseLetterContext.Provider value={[state, dispatch]}>
      {children}
    </ResponseLetterContext.Provider>
  );
};
export default ResponseLetterContextProvider;